import { useContext } from "react";
import { PortalAuthConfigContext, type PortalAuthConfig } from "./portalAuthConfig";

/** Reads the portal's auth config. Throws outside a `PortalAuthProvider`. */
export function usePortalAuthConfig(): PortalAuthConfig {
  const ctx = useContext(PortalAuthConfigContext);
  if (!ctx) {
    throw new Error("usePortalAuthConfig must be used within a PortalAuthProvider");
  }
  return ctx;
}
